// material-ui

import steeringrRearAxle from '../../../assets/images/qualifications/steeringr-rear-axle.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const SteeringrRearAxle = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={steeringrRearAxle} alt="SteeringrRearAxle" height={props.height || 25}  />
    );
};

export default SteeringrRearAxle;